const {
  adminUrl,
  ajaxUrl,
  restUrl,
  backgroundIframeUrl,
  deviceId,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hubspotBaseUrl,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  ajaxNonce,
  restNonce,
  redirectNonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  signupUrl,
  portalDomain,
  leadinQueryParamsKeys,
  oauth,
} = window.leadinConfig;

const i18n = window.leadinI18n;

export {
  adminUrl,
  ajaxUrl,
  restUrl,
  backgroundIframeUrl,
  deviceId,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hubspotBaseUrl,
  i18n,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  ajaxNonce,
  restNonce,
  redirectNonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  signupUrl,
  portalDomain,
  leadinQueryParamsKeys,
  oauth,
};
